class MrkCarouselTab extends HTMLElement {
  constructor() {
    super();

    this.isVertical = false // 默认横版
    this.autoChangeTimer = null; // 自动播放
    this.autoChangeTime = 5000; // 自动播放时间
    this.isAutoChange = 'true';
    this.loopTimer = null;
    this.loopTime = 300;
    this.isInited = false; // 未初始化
    this.currentClass = 'active';
    this.lowClass = 'z-index-low';
    this.lowClassSecondly = 'z-index-low-secondly';
    this.itemIndex = 'data-index'

    this.gap = 20;
    this.currentIndex = 0;
    this.prevIndex = 0;
    this.boxWidth = 0;
    this.isAnimate = false; // 动画锁：防止快速操作导致错乱

    this.connectedCallback();
  }

  initCarousel() {
    this.isInited = true;
    this.isAutoChange = this.getAttribute('auto-play');
    this.isVertical = !!this.getAttribute('vertical');
    this.element = this.getElements();
    this.originCount = this.element.slides.length;

    this.reinitItems(); // 计算宽度
    this.bindAllEvents(); // 统一绑定所有事件
    this.resetTrackPosition(); // 初始化轨道位置
    if (this.isAutoChange === 'true') this.handleAutoChange(); // 自动播放
    
    const currentTabNode = this.element.tabItems[this.currentIndex]
    this.handleBorder()
    this.handleSelectTab(currentTabNode);
  }

  getElements() {
    return {
      contentGroup: this.querySelector('.mrk-content-group'),
      contentItems: this.querySelectorAll('.mrk-content-group .item'),
      carouselGroup: this.querySelector('.mrk-carousel-group'),
      carouselSlides: this.querySelector('.mrk-carousel-slides'),
      slides: this.querySelectorAll('.mrk-carousel-slide'),
      tabs: this.querySelector('.tabs'),
      tabItems: this.querySelectorAll('.tabs .item'),
      progress: this.querySelector('.border .progress'),
      border: this.querySelector('.border'),
      prevBtn: this.querySelector('.prevBtn'),
      nextBtn: this.querySelector('.nextBtn')
    }
  }

  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }

  init() {
    if (!this.isInited) {
      this.initCarousel(); // 轮播核心初始化逻辑
    };
  }

  // 计算宽度
  reinitItems() {
    this.boxWidth = this.element.carouselGroup.getBoundingClientRect().width;
  }

  // 绑定所有事件
  bindAllEvents() {
    this.element.tabItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        if (this.isAnimate) return;
        const itemIndex = parseFloat(item.getAttribute(this.itemIndex));
        this.prevIndex = this.currentIndex;
        this.currentIndex = itemIndex;
        this.handleOrbitalPosition(e.target)
      });
    })

    // 移动端滑动事件
    let startX = 0, moveX = 0, isMoving = false, startY = 0;
    this.element.carouselSlides.addEventListener('touchstart', (e) => {
      if (this.isAnimate) return;
      isMoving = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });

    this.element.carouselSlides.addEventListener('touchmove', (e) => {
      if (!isMoving || this.isAnimate) return;
      moveX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;
      if (Math.abs(moveX) > Math.abs(deltaY)) {
        e.preventDefault();
      }
    }, { passive: false });

    this.element.carouselSlides.addEventListener('touchend', () => {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      const threshold = this.boxWidth * 0.2; // 滑动阈值：30%宽度
      this.prevIndex = this.currentIndex;
      if (moveX > threshold) this.currentIndex--;
      else if (moveX < -threshold) this.currentIndex++;
      if (this.prevIndex === this.currentIndex) return;
      if (this.currentIndex < 0) {
        this.currentIndex = this.originCount - 1;
      } else if (this.currentIndex > this.originCount - 1) {
        this.currentIndex = 0;
      }
      
      const currentTabNode = this.element.tabItems[this.currentIndex]
      this.handleOrbitalPosition(currentTabNode);
      startX = 0;
      moveX = 0;
    });

    this.element.carouselSlides.addEventListener('touchcancel', () => {
      if (!isMoving || this.isAnimate) return;
      isMoving = false;
      const threshold = this.boxWidth * 0.2; // 滑动阈值：30%宽度
      this.prevIndex = this.currentIndex;
      if (moveX > threshold) this.currentIndex--;
      else if (moveX < -threshold) this.currentIndex++;
      if (this.prevIndex === this.currentIndex) return;
      if (this.currentIndex < 0) {
        this.currentIndex = this.originCount - 1;
      } else if (this.currentIndex > this.originCount - 1) {
        this.currentIndex = 0;
      }
      
      const currentTabNode = this.element.tabItems[this.currentIndex]
      this.handleOrbitalPosition(currentTabNode);
      startX = 0;
      moveX = 0;
    });
  
    // 窗口大小变化适配
    window.addEventListener('resize', () => {
      if (this.isAnimate) return;
      let timer = setTimeout(() => {
        this.reinitItems();
        const currentItemNode = this.element.tabItems[this.currentIndex]
        this.handleSelectTab(currentItemNode);
        this.updateCarousel();

        clearTimeout(timer)
        timer = null
      }, 100)
    });

    if (this.element.nextBtn) {
      this.element.nextBtn.addEventListener('click', () => {
        if (this.isAnimate) return;
        this.prevIndex = this.currentIndex;
        this.currentIndex++;
        if (this.currentIndex > this.originCount - 1) {
          this.currentIndex = 0;
        }
        
        const currentTabNode = this.element.tabItems[this.currentIndex]
        this.handleOrbitalPosition(currentTabNode);
      });
    }
    if (this.element.prevBtn) {
      this.element.prevBtn.addEventListener('click', () => {
        if (this.isAnimate) return;
        this.prevIndex = this.currentIndex;
        this.currentIndex--;
        if (this.currentIndex < 0) {
          this.currentIndex = this.originCount - 1;
        }
        
        const currentTabNode = this.element.tabItems[this.currentIndex]
        this.handleOrbitalPosition(currentTabNode);
      });
    }
  }

  // 切换轨道位置
  handleOrbitalPosition(currentItemNode) {
    this.updateCarousel();
    this.handleSelectTab(currentItemNode);
    this.handleSelectContentItem();
  }

  handleAutoChange() {
    if (!this.autoChangeTimer) {
      this.autoChangeTimer = setInterval(() => {
        if (this.isAnimate) return;
        this.prevIndex = this.currentIndex;
        if (this.currentIndex === this.originCount - 1) {
          this.currentIndex = 0;
        } else {
          this.currentIndex++;
        }
        const currentTabNode = this.element.tabItems[this.currentIndex]
        this.handleOrbitalPosition(currentTabNode)
      }, this.autoChangeTime)
    }
  }

  // 重置轨道位置：无过渡瞬间跳转（循环/窗口缩放用）
  resetTrackPosition() {
    const widthPoor = this.boxWidth;
    const marginPoor = this.gap;

    this.element.slides.forEach((item, index) => {
      if (index === this.currentIndex) {
        item.classList.add(this.currentClass);
        item.style.transform = `translateX(0px)`;
      } else {
        const translateX = widthPoor * index + marginPoor * index;
        item.style.transform = `translateX(${translateX}px)`;
      }
    })
    void this.element.carouselSlides.offsetWidth; // 强制重绘，防止过渡失效
  }

  // 核心更新方法：滑动+指示器+循环判断
  updateCarousel() {
    if (this.prevIndex === this.currentIndex) return;
    this.isAnimate = true; // 开启动画锁
    const widthPoor = this.boxWidth;
    const marginPoor = this.gap;

    this.element.slides.forEach((item, index) => {
      item.style.transition = `all ${this.loopTime / 1000}s`;
      item.classList.remove(this.currentClass);
      item.classList.remove(this.lowClass);
      item.classList.remove(this.lowClassSecondly);
      const itemIndex = parseFloat(item.getAttribute(this.itemIndex));

      if (this.currentIndex === 0 && this.prevIndex === this.originCount - 1) {
        if (this.originCount - 1 !== itemIndex) {
          if (this.currentIndex === itemIndex) {
            item.classList.add(this.currentClass);
          }
          const currentIndex = Math.abs(itemIndex - this.currentIndex);
          const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
          item.style.transform = `translateX(${translateX}px)`;
        }
      } else if (this.currentIndex === this.originCount - 1 && this.prevIndex === 0) {
        if (this.currentIndex === itemIndex) {
          item.classList.add(this.currentClass);
          item.classList.add(this.lowClass);
          item.style.transition = '';
          item.style.transform = `translateX(0px)`;
        } else {
          const currentIndex = Math.abs(this.originCount - this.currentIndex + itemIndex);
          const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
          item.style.transform = `translateX(${translateX}px)`;
        }
      } else if (this.currentIndex > this.prevIndex) {
        let currentIndex = Math.abs(itemIndex - this.currentIndex);
        if (itemIndex === this.currentIndex) {
          item.classList.add(this.currentClass);
          item.style.transform = `translateX(0px)`;
        } else {
          if (itemIndex !== this.prevIndex) {
            if (itemIndex > this.prevIndex && itemIndex < this.currentIndex) {
              item.style.transform = `translateX(0px)`;
            } else {
              if (itemIndex < this.currentIndex) {
                currentIndex = Math.abs(this.originCount - this.currentIndex + itemIndex);
              }
              const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
              item.style.transform = `translateX(${translateX}px)`;
            }
          }
        }
      } else if (this.currentIndex < this.prevIndex) {
        if (itemIndex === this.currentIndex) {
          item.classList.add(this.currentClass);
          item.classList.add(this.lowClass);
          item.style.transition = '';
          item.style.transform = `translateX(0px)`;
        } else if (itemIndex > this.currentIndex && itemIndex < this.prevIndex) {
          item.classList.add(this.lowClassSecondly);
          item.style.transition = '';
          item.style.transform = `translateX(0px)`;
          void this.element.carouselSlides.offsetWidth;
          const currentIndex = Math.abs(itemIndex - this.currentIndex);
          item.style.transition = `all ${this.loopTime / 1000}s`;
          const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
          item.style.transform = `translateX(${translateX}px)`;
        } else {
          let currentIndex = Math.abs(this.originCount - this.currentIndex + itemIndex);
          if (itemIndex > this.currentIndex) {
            currentIndex = Math.abs(itemIndex - this.currentIndex);
          } else {
            item.style.transition = '';
          }
          const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
          item.style.transform = `translateX(${translateX}px)`;
        }
      }
    })
    void this.element.carouselSlides.offsetWidth; // 强制重绘，防止过渡失效

    // 动画结束后处理循环，单次监听防止重复触发
    clearTimeout(this.loopTimer);
    this.loopTimer = setTimeout(() => {
      this.handleLoop();
      clearTimeout(this.loopTimer);
    }, this.loopTime)
  }

  // 无缝循环处理：到达复制节点时瞬间切回原节点
  handleLoop() {
    const widthPoor = this.boxWidth;
    const marginPoor = this.gap;
    this.element.slides.forEach((item, index) => {
      const itemIndex = parseFloat(item.getAttribute(this.itemIndex));
      
      item.style.transition = '';

      if (this.currentIndex === 0 && this.prevIndex === this.originCount - 1) {
        if (this.originCount - 1 === itemIndex) {
          const translateX = widthPoor * itemIndex + marginPoor * itemIndex;
          item.style.transform = `translateX(${translateX}px)`;
        }
      } else if (this.currentIndex > this.prevIndex) {
        if (itemIndex === this.prevIndex) {
          const currentIndex = Math.abs(this.originCount - this.currentIndex + itemIndex);
          const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
          item.style.transform = `translateX(${translateX}px)`;
        } else {
          if (itemIndex !== this.prevIndex) {
            if (itemIndex > this.prevIndex && itemIndex < this.currentIndex) {
              const currentIndex = Math.abs(this.originCount - this.currentIndex + itemIndex);
              const translateX = widthPoor * currentIndex + marginPoor * currentIndex;
              item.style.transform = `translateX(${translateX}px)`;
            }
          }
        }
      }
    })
    
    void this.element.carouselSlides.offsetWidth;
    this.isAnimate = false; // 关闭动画锁
  }

  // 切换 tab 内容
  handleSelectContentItem() {
    this.element.contentItems.forEach((item) => {
      const itemIndex = parseFloat(item.getAttribute(this.itemIndex));
      if (itemIndex === this.currentIndex) {
        item.classList.add(this.currentClass)
      } else {
        item.classList.remove(this.currentClass)
      }
    })
  }

  handleBorder() {
    if (this.isVertical) {
      if (this.element.tabItems && this.element.tabItems[0]) {
        const itemNode = this.element.tabItems[0]
        const height = itemNode.offsetHeight
        this.element.progress.style.height = `${height}px`
      }
    } else {
      this.element.border.style.width = `${this.element.tabs.scrollWidth}px`
    }
  }

  // 切换滚动条位置
  handleSelectTab(currentTarge) {
    const childRect = currentTarge.getBoundingClientRect();
    const parentRect = this.element.tabs.getBoundingClientRect();
  
    this.element.tabItems.forEach(tabItem => {
      tabItem.classList.remove(this.currentClass)
    })
    currentTarge.classList.add(this.currentClass)

    if (this.isVertical) {
      const currentHeight = currentTarge.offsetHeight
      const relativeTop = currentHeight * this.currentIndex;
      this.element.progress.style.top = `${relativeTop}px`
    } else {
      // 横版
      const currentWidth = currentTarge.offsetWidth
      const progressWidth = this.element.progress.offsetWidth
      const borderLeft = this.element.border.offsetLeft
      let oldRelativeLeft = childRect.left - parentRect.left;
      oldRelativeLeft += this.element.tabs.scrollLeft;
      const relativeLeft = oldRelativeLeft + currentWidth / 2 - progressWidth / 2 - borderLeft;
  
      // this.element.progress.style.width = `${currentWidth}px`
      this.element.progress.style.left = `${relativeLeft}px`
  
      this.scrollscroll(currentTarge)
    }
  }

  // 滚动滚动条
  scrollscroll(currentTarge) {
    const currentWidth = currentTarge.offsetWidth
    const borderLeft = this.element.border.offsetLeft
    const boxWidth = this.element.carouselGroup.offsetWidth
    const leftScroll = currentTarge.offsetLeft - boxWidth + boxWidth / 2 + currentWidth / 2 - borderLeft
    if (leftScroll > 0) {
      this.element.tabs.scrollTo({ left: leftScroll, behavior: 'smooth' })
    } else {
      this.element.tabs.scrollTo({ left: 0 })
    }
  }
}
customElements.define("mrk-carousel-tab", MrkCarouselTab);

document.addEventListener('DOMContentLoaded', () => {
  let resizeTimer = null;

  setTableBorder();
  
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setTableBorder();
    }, 200);
  });
});

// 设置对比表格的高亮边框
function setTableBorder() {
  const tableBoxNode = document.querySelector('.compare-table-custom-section');
  if (tableBoxNode) {
    const tableNode = tableBoxNode.querySelector('.custom-table');
    if (tableNode) {
      const activeBorder = tableNode.querySelector('.item.active .active-border');
      const activeBorderBg = tableNode.querySelector('.item.active .active-border-bg');
      const tableHeight = tableNode.offsetHeight + 56;
      activeBorder.style.height = `${tableHeight}px`
      activeBorderBg.style.height = `${tableHeight - 6}px`
    }
  }
}